<template>
  <teleport to="#modalTeleport">
    <ConfirmModal ref="confirmModal"></ConfirmModal>
  </teleport>
  <HeadlineComponent :subtitle="`Insgesamt ${events.length}`"
    >Veranstaltungen</HeadlineComponent
  >
  <RouterLink to="/events/create" class="btn btn-sm btn-primary"
    >Neue Veranstaltung</RouterLink
  >
  <div class="form-check mb-3">
    <input
      type="checkbox"
      v-model="all_events"
      @change="refresh()"
      id="all_events"
      class="form-check-input"
    />
    <label class="form-check-label user-select-none" for="all_events">
      Auch vergangene Veranstaltungen zeigen
    </label>
  </div>
  <template v-for="event of events" :key="event.id">
    <div class="guest mb-4">
      <div>
        <span>{{ event.name }}</span>
      </div>
      <div class="system-info">
        <span v-if="ticketing_enabled || guests_enabled">
          <RouterLink
            :to="`/events/${event.id}/ticketTemplates`"
            v-if="ticketing_enabled"
            >Ticket Templates</RouterLink
          >
          |
          <RouterLink :to="`/events/${event.id}/guest`" v-if="guests_enabled"
            >Gäste</RouterLink
          >
          |
          <RouterLink
            :to="`/events/${event.id}/reports/catering`"
            v-if="dietary_enabled"
            >Catering Report</RouterLink
          >
          |
          <RouterLink :to="`/user/broadcast?event_id=${event.id}`"
            >SMS Broadcast</RouterLink
          >
          |
          <RouterLink :to="`/user/broadcast/mail?event_id=${event.id}`"
            >Mail Broadcast</RouterLink
          >
          |
          <RouterLink :to="`/events/${event.id}/badges`"
            >Badge Export</RouterLink
          >
          <br />
        </span>
        <RouterLink
          :to="`/events/${event.id}`"
          class="btn btn-primary btn-sm mt-2"
          >Bearbeiten <span class="fa fa-pencil"></span
        ></RouterLink>
        <LoadingButton
          @click="deleteEvent(event)"
          class="btn-danger btn-sm mt-2"
          :loading="event.loading"
          >Löschen <span class="fa fa-remove"></span
        ></LoadingButton>
      </div>
    </div>
    <hr class="mb-4 volunteer-hr" />
  </template>
</template>

<script>
import { mapActions, mapState } from "pinia";
import { useAlertsStore } from "@/stores/alerts.js";
import LoadingButton from "@/components/LoadingButton.vue";
import HeadlineComponent from "@/components/HeadlineComponent.vue";
import eventService from "@/services/event.service";
import ConfirmModal from "@/components/ConfirmModal.vue";
import { useConfigStore } from "@/stores/config";
import * as Sentry from '@sentry/vue';

export default {
  name: "EventsView",
  components: { LoadingButton, HeadlineComponent, ConfirmModal },
  data() {
    return {
      events: [],
      loading: false,
      all_events: false,
    };
  },
  async beforeMount() {
    this.all_events = this.$route.query.all_events;
    try {
      let response = await eventService.index(this.all_events);
      this.events = response.data;
    } catch (e) {
      if (e) {
        Sentry.captureException(e);
        this.addAlert("danger", "Es ist was unerwartetes schief gegangen..");
        window.scrollTo(0, 0);
      }
    }
  },
  computed: {
    ...mapState(useConfigStore, [
      "ticketing_enabled",
      "guests_enabled",
      "dietary_enabled",
    ]),
  },
  methods: {
    ...mapActions(useAlertsStore, { addAlert: "add" }),
    async refresh() {
      this.$router.push({ query: { all_events: this.all_events } });
      let response = await eventService.index(this.all_events);
      this.events = response.data;
    },

    async deleteEvent(event) {
      event.loading = true;
      if (
        await this.$refs.confirmModal.show(
          "Veranstaltung löschen",
          `Soll die Veranstaltung ${event.name} wirklich gelöscht werden?`
        )
      ) {
        try {
          await eventService.remove(event.id);
          this.addAlert(
            "success",
            "Die Veranstaltung wurde erfolgreich gelöscht."
          );
          for (let i = 0; i < this.events.length; i++) {
            if (this.events[i].id === event.id) {
              this.events.splice(i, 1);
              break;
            }
          }
        } catch (e) {
          if (e) {
            Sentry.captureException(e);
            this.addAlert(
              "danger",
              "Es ist was unerwartetes schief gegangen.."
            );
            window.scrollTo(0, 0);
          }
          event.loading = false;
        }
      } else {
        event.loading = false;
      }
    },
  },
};
</script>

<style scoped></style>
